module.exports = __webpack_public_path__ + "media/sounds/print_correct-f841ec512711a76ad25253bdb25907ac.wav";